import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import AssignmentIcon from '@mui/icons-material/Assignment';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import moment from 'moment-timezone';


import Copyright from '../../components/Copyright';
import DrawerMenu from '../../components/DrawerMenu';
import Title from '../../components/Title';
import TopBar from '../../components/TopBar';
import useStyles from '../../useStyles';
import LastEvents from './LastEvents';


export default function LastEventsPage() {
  console.log("VEZO @ LastEventsPage ")
  const classes = useStyles();
  const [dateBegin,setDateBegin] = useState(moment(new Date()).subtract(1,'weeks'));
  const [dateEnd,setDateEnd] = useState(moment(new Date()));
  const [go,setGo] = useState(false)
  
  var stores = JSON.parse(sessionStorage.getItem('stores'));
  stores = stores.map((el)=>({
    "store_id": el.id,
    "store_name": el.store_name
  }))
  const [openSelect, setOpenSelect] = React.useState(false);
  const [selectedStore, setSelectedStore] = React.useState('');


  const handleChange = (event) => {
    setSelectedStore(event.target.value);
  };

  const handleClose = () => {
    setOpenSelect(false);
  };

  const handleOpen = () => {
    setOpenSelect(true);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <TopBar hideStore={true}/>
      <DrawerMenu/>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={3} justifyContent={"flex-start"} direction="row">
              <Grid item xs={12} md={12} lg={12}>
                <Title> <AssignmentIcon /> Eventos</Title>
              </Grid> 
              <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                  <Grid container alignItems={"center"} spacing={3} justifyContent="space-between" direction="row">
                    <Grid item xs={12} md={6} lg={6}>
                      <Grid container spacing={1} alignItems={"stretch"} justifyContent={"space-between"} direction="column">
                        <FormControl className={{maxWidth:100}} variant="standard">
                            <InputLabel id="demo-controlled-open-select-label">  Loja  </InputLabel>
                            <Select
                            labelId="demo-controlled-open-select-label"
                            id="demo-controlled-open-select"
                            open={openSelect}
                            onClose={handleClose}
                            onOpen={handleOpen}
                            value={selectedStore}
                            onChange={handleChange}
                            >
                                {stores.map((store)=>{
                                    return(
                                      <MenuItem value={store.store_id}>{store.store_name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <LocalizationProvider style={classes.localizationProvider}dateAdapter={DateFnsUtils}>
                      <Grid container justifyContent="space-around" variant="standard">
                        <DatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Data inicio"
                          inputFormat="dd/MM/yyyy" 
                          value={dateBegin}
                          onChange={(date)=>{setDateBegin(moment(date))}}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          renderInput={(props) => <TextField {...props} variant="standard"/>}
                        />
                        <DatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Data fim"
                          inputFormat="dd/MM/yyyy" 
                          value={dateEnd}
                          onChange={(date)=>{setDateEnd(moment(date))}}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          renderInput={(props) => <TextField {...props} variant="standard"/>}
                        />
                      </Grid>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <Button variant="outlined" color="primary"
                      justify="center"
                      onClick={()=>{
                        if(!dateBegin || !dateEnd || !selectedStore){
                          alert("Selecionar valores!")
                        }
                        else{
                          setGo(true)
                        }
                      }}>
                        Procurar
                    </Button>
                  </Grid>
                 </Grid>    
                </Paper>
              </Grid>
              {
                (openSelect || !selectedStore || !go)? 
                  null   
                :
                <Grid item xs={12} md={12} lg={12}>
                  <div className={classes.appBarSpacer} />
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Paper className={classes.paper}>
                        <LastEvents store_id={selectedStore} date={[dateBegin.format('YYYY-MM-DD'),dateEnd.format('YYYY-MM-DD')]}/>
                      </Paper>
                    </Grid>
                  </Grid>
                  <Box pt={4}>
                    <Copyright />
                  </Box>
                </Grid>
              }
            </Grid>
          </Container>
      </main>
    </div>
  );
}
